// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-primary {
  background-color: var(--green) !important;
  color: var(--white) !important;
  border: none !important;
  outline: none !important;
}
.btn-primary-glow {
  box-shadow: 0.125rem 0.125rem 1rem -0.125rem var(--green);
  -webkit-box-shadow: 0.125rem 0.125rem 1rem -0.125rem var(--green);
  -moz-box-shadow: 0.125rem 0.125rem 1rem -0.125rem var(--green);
}
.header-btn {
  min-width: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/button.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,yDAAyD;EACzD,iEAAiE;EACjE,8DAA8D;AAChE;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".btn-primary {\n  background-color: var(--green) !important;\n  color: var(--white) !important;\n  border: none !important;\n  outline: none !important;\n}\n.btn-primary-glow {\n  box-shadow: 0.125rem 0.125rem 1rem -0.125rem var(--green);\n  -webkit-box-shadow: 0.125rem 0.125rem 1rem -0.125rem var(--green);\n  -moz-box-shadow: 0.125rem 0.125rem 1rem -0.125rem var(--green);\n}\n.header-btn {\n  min-width: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
